import './index.scss';
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { get, post } from '../../../util/request';
import { useSelector } from 'react-redux';
import { userInfo } from '../../../redux/slice';
import { useHistory } from 'react-router';
import { Form, Popover } from 'antd';
import { useParams } from 'react-router-dom';
import Loading from '../../../components/common/loading.js';
import BankAccountSubmitSuccessPopUp from '../bankAccountSubmitSuccessPopUp/index.js';
import BankAccountMFAPopUp from '../bankAccountMFAPopUp/index.js';
import Dropdown from 'react-bootstrap/Dropdown';
import BankAccountDisclaimerModal from '../bankAccountDisclaimerModal/index.js';

export default BankAccountForm; function BankAccountForm() {
    const FormItem = Form.Item;
    const formRef = useRef();
    const history = useHistory();
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const { action, syndicationCurrency } = useParams();
    const [error, setError] = useState('');
    const [bankAccountData, setBankAccountData] = useState({});
    const [mOPCountries, setMOPCountries] = useState([]);
    const [mOPCurrencies, setMOPCurrencies] = useState([]);
    const [brdgXCodes, setBrdgXCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalProperty, setModalProperty] = useState({ isModalOpen: false, title: '', content: '', icon: '' })
    const [disclaimerModalProperty, setdisclaimerModalProperty] = useState({ isModalOpen: false, contentDisclaimer: '', contentFee: '', type: '' })
    const [isBankNameMenuOpen, setIsBankNameMenuOpen] = useState(false);
    const [bankName, setBankName] = useState('');
    const typingTimeout = useRef(null);
    const [content, setContent] = useState({});
    const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
    const accountRegex = /^\d{6,20}$/;
    const accountNumberOrIBANRegex = /^(?:[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}|\d{6,20})$/;
    const bankNameRegex = /^[A-Za-z0-9 ,.#()-]+$/;
    const [accountType, setAccountType] = useState('');
    const [viewOnlyDisclaimer, setViewOnlyDisclaimer] = useState('');
    const [isRequiredValidation, setIsRequiredValidation] = useState({ intermediaryBankName: false, intermediaryBankSWIFT: false, intermediaryBankFullAddress: false, swift: true });
    const [mfaModalProperty, setMfaModalProperty] = useState({ isModalOpen: false, maskedEmail: '', referenceId: '' });
    const [branchCodeNote, setBranchCodeNote] = useState('');
    const countries = ['HKG', 'USA', 'GBR', 'CAN'];
    const [userAgree, setUserAgree] = useState(false);
    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));
    const [useFor, setUseFor] = useState({ cad: false, usd: false });
    const [showMore, setShowMore] = useState(false);

    const goto = () => {
        history.push({
            pathname: user.sfUserType === 'CL' ? '/bankAccount' : '/preview/bankAccount'
        });
    }

    const contactUs = () => {
        history.push({
            pathname: user.sfUserType === 'CL' ? '/contactUs' : '/preview/contactUs'
        });
    }

    const cleanBankDetails = () => {
        const values = formRef.current?.getFieldsValue();

        if (!values) return;

        const trimmedValues = Object.fromEntries(
            Object.entries(values).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.trim() : value,
            ])
        );

        formRef.current?.setFieldsValue(trimmedValues);
    };

    const submitBankAccount = () => {
        if (user.sfUserType === 'CL') {
            cleanBankDetails();

            formRef?.current
                ?.validateFields()
                .then(() => {
                    if (!error) {
                        submitMFA();
                    } else {
                        const errorList = document.querySelectorAll(".error-message")
                        errorList[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                })
                .catch((err) => {
                    const errorList = document.querySelectorAll(".ant-form-item-has-error")
                    errorList[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                });
        }
    }

    useEffect(() => {
        if (action.toLowerCase() === 'edit') {
            setLoading(true);
            getUpdateDetail();
        }
        else if (action.toLowerCase() === 'view') {
            getViewDetail();
        }
        else if (action.toLowerCase() === 'add') {
            getMOPCountries(user.sfUserType === 'CL' ? user.salesOffice : previewDetail?.salesOffice);
            getMOPCurrencies();
            formRef.current?.setFieldsValue({ bankAccountName: user.sfUserType === 'CL' ? user.fullName : previewDetail?.fullName });
            formRef.current?.setFieldsValue({ accountHolderLastName: user.sfUserType === 'CL' ? user.lastName : previewDetail?.lastName });
            formRef.current?.setFieldsValue({ accountHolderFirstName: user.sfUserType === 'CL' ? user.firstName : previewDetail?.firstName });
        }
        else {
            //to avoid unauthorized action
            goto();
        }

        getContent();

        if (action.toLowerCase() !== 'view') {
            if (syndicationCurrency.toLowerCase() === 'usd') {
                const useForUSD = document.getElementsByName('use-for-usd')[0];
                if (useForUSD !== null) {
                    useForUSD.checked = true;
                    useForUSD.disabled = true;
                }
            }
            else {
                const useForCAD = document.getElementsByName('use-for-cad')[0];
                if (useForCAD !== null) {
                    useForCAD.checked = true;
                    useForCAD.disabled = true;
                }
            }
        }

        //add function to disclaimer / fee
        disclaimerOnClick();

    }, []);


    const disclaimerOnClick = () => {
        const disclaimerButton = document.getElementById('disclaimer');
        if (disclaimerButton) {
            disclaimerButton.onclick = () => viewDisclaimer('Disclaimer', 'true');
        }

        const feeButton = document.getElementById('fee');
        if (feeButton) {
            feeButton.onclick = () => viewDisclaimer('Fee', 'true');
        }
    }

    useEffect(() => {
        if (Object.keys(content).length > 0) {
            let disclaimerTemplate = '';
            let feeTemplate = '';
            switch (window.localStorage.lang) {
                case 'ZH_CN':
                case 'zh_CN':
                case 'Simplified Chinese':
                    disclaimerTemplate = content.find(x => x.type.includes('Disclaimer') && x.type.includes(user.salesOffice)).contentsc;
                    feeTemplate = content.find(x => x.type.includes('Fee') && x.type.includes(user.salesOffice)).contentsc;
                    setViewOnlyDisclaimer(content.find(x => x.type.includes('View only') && x.type.includes(user.salesOffice)).contentsc);
                    break;
                case 'ZH_HK':
                case 'zh_HK':
                case 'Traditional Chinese':
                    disclaimerTemplate = content.find(x => x.type.includes('Disclaimer') && x.type.includes(user.salesOffice)).contenttc;
                    feeTemplate = content.find(x => x.type.includes('Fee') && x.type.includes(user.salesOffice)).contenttc;
                    setViewOnlyDisclaimer(content.find(x => x.type.includes('View only') && x.type.includes(user.salesOffice)).contenttc);
                    break;
                case 'JP':
                case 'jp':
                case 'Japanese':
                    disclaimerTemplate = content.find(x => x.type.includes('Disclaimer') && x.type.includes(user.salesOffice)).contentja;
                    feeTemplate = content.find(x => x.type.includes('Fee') && x.type.includes(user.salesOffice)).contentja;
                    setViewOnlyDisclaimer(content.find(x => x.type.includes('View only') && x.type.includes(user.salesOffice)).contentja);
                    break;
                default:
                    disclaimerTemplate = content.find(x => x.type.includes('Disclaimer') && x.type.includes(user.salesOffice)).contenten;
                    feeTemplate = content.find(x => x.type.includes('Fee') && x.type.includes(user.salesOffice)).contenten;
                    setViewOnlyDisclaimer(content.find(x => x.type.includes('View only') && x.type.includes(user.salesOffice)).contenten);
                    break;
            }
            setdisclaimerModalProperty(prevData => ({
                ...prevData,
                contentDisclaimer: disclaimerTemplate,
                contentFee: feeTemplate
            }));

            disclaimerOnClick();
        }
    }, [window.localStorage.lang, content]);

    const viewDisclaimer = async (type, modal) => {
        setdisclaimerModalProperty(prevData => ({
            ...prevData,
            type: type,
            isModalOpen: modal
        }))
    }


    const getUpdateDetail = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        }
        const data = await get(`/bankAccount/syndication/${syndicationCurrency.toUpperCase()}`, params).catch(() => {
            setModalProperty({
                isModalOpen: true,
                icon: 'submit-error',
                title: 'error',
                content: 'The specified syndication currency does not exist.'
            });
            setLoading(false);
        });

        if (data) {
            setBankAccountData(data);
            formRef.current?.setFieldsValue(data);
            formRef.current?.setFieldsValue({ accountNumber: removeExcessChar(data.accountNumber) });
            formRef.current?.setFieldsValue({ bankCode: removeExcessChar(data.bankCode) });
            formRef.current?.setFieldsValue({ branchCode: removeExcessChar(data.branchCode) });
            formRef.current?.setFieldsValue({ syndicationCurrency: removeExcessChar(syndicationCurrency) });
            getMOPCountries(data.salesOffice);
            getMOPCurrencies();
            getBrdgXCodes(data.bankCountry, data.bankName);
            setBankName(data.bankName);
            setAccountType(ibanRegex.test(removeExcessChar(data.accountNumber)) ? 'AccountTypeIBAN' : accountRegex.test(removeExcessChar(data.accountNumber)) ? 'AccountTypeAccountNumber' : '');

            setIsRequiredValidation(prevData => ({
                ...prevData,
                intermediaryBankName: data.intermediaryBankAccountNumber.trim() !== '' ? true : false,
                intermediaryBankSWIFT: data.intermediaryBankAccountNumber.trim() !== '' ? true : false,
                intermediaryBankFullAddress: data.intermediaryBankAccountNumber.trim() !== '' ? true : false,
                swift: data.brdgxBankCode !== '' ? false : true
            }));


            if (countries.includes(data.bankCountry)) {
                setBranchCodeNote(data.bankCountry + '_Note_Code');
            }
            else {
                setBranchCodeNote('');
            }

            setLoading(false);
        }
    }

    const getViewDetail = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        }
        const data = await get(`/bankAccount/phase/${syndicationCurrency.toUpperCase()}`, params).catch(() => {
            setModalProperty({
                isModalOpen: true,
                icon: 'submit-error',
                title: 'error',
                content: 'The specified phase does not exist.'
            });
            setLoading(false);
        });
        if (data) {

            setBankAccountData(data);
            formRef.current?.setFieldsValue(data);
            formRef.current?.setFieldsValue({ accountNumber: removeExcessChar(data.accountNumber) });
            formRef.current?.setFieldsValue({ bankCode: removeExcessChar(data.bankCode) });
            formRef.current?.setFieldsValue({ branchCode: removeExcessChar(data.branchCode) });
            formRef.current?.setFieldsValue({ syndicationCurrency: removeExcessChar(syndicationCurrency) });
            getMOPCountries(data.salesOffice);
            getMOPCurrencies();
            getBrdgXCodes(data.bankCountry, data.bankName);
            setBankName(data.bankName);
            setAccountType(ibanRegex.test(removeExcessChar(data.accountNumber)) ? 'AccountTypeIBAN' : accountRegex.test(removeExcessChar(data.accountNumber)) ? 'AccountTypeAccountNumber' : '');
            if (countries.includes(data.bankCountry)) {
                setBranchCodeNote(data.bankCountry + '_Note_Code');
            }
            else {
                setBranchCodeNote('');
            }

            setIsRequiredValidation(prevData => ({
                ...prevData,
                intermediaryBankName: data.intermediaryBankAccountNumber.trim() !== '' ? true : false,
                intermediaryBankSWIFT: data.intermediaryBankAccountNumber.trim() !== '' ? true : false,
                swift: data.brdgxBankCode !== '' ? false : true
            }));
        }
        setLoading(false);
    }

    const getContent = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        }
        const data = await get('/bankAccount/content', params);
        if (data) {
            setContent(data);
        }
    }

    const getMOPCountries = async (salesOffice) => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId,
            salesOffice: salesOffice
        }
        const data = await get('/bankAccount/mopCountries', params);
        if (data) {
            setMOPCountries(data);
            if (action.toLowerCase() === 'add') {
                formRef.current.setFieldValue('bankCountry', data[0].countryCode);
                getBrdgXCodes(data[0].countryCode, ''); //Default

                if (countries.includes(data[0].countryCode)) {
                    setBranchCodeNote(data[0].countryCode + '_Note_Code');
                }
                else {
                    setBranchCodeNote('');
                }
            }
        }
    }

    const getMOPCurrencies = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        }
        const data = await get('/bankAccount/mopCurrencies', params);
        if (data) {
            setMOPCurrencies(data);
            if (action.toLowerCase() === 'add') {
                formRef.current.setFieldValue('accountCurrency', data[0].currency);
            }
        }
    }

    const getBrdgXCodes = async (countryCode, name) => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId,
            countryCode: countryCode,
            name: name
        }
        const data = await get('/bankAccount/brdgXCodes', params);
        if (data) {
            setBrdgXCodes(data);
        }
    }


    //#region Bank Name
    const handleBankNameChange = (value) => {
        setBankName(value);
        if (bankNameRegex.test(value)) {
            clearTimeout(typingTimeout.current)
            typingTimeout.current = setTimeout(() => {
                getBrdgXCodes(formRef?.current?.getFieldValue('bankCountry'), value);
                formRef?.current?.setFieldValue('bankName', value);
                formRef?.current?.setFieldValue('brdgxBankCode', '');
                setIsRequiredValidation(prevData => ({
                    ...prevData,
                    swift: true
                }));
            }, 1000);
        }
    }

    const handleBankCountryChange = (value) => {
        if (countries.includes(value)) {
            setBranchCodeNote(value + '_Note_Code');
        }
        else {
            setBranchCodeNote('');
        }
        getBrdgXCodes(value, '')
        setBankName('')
        formRef?.current?.setFieldValue('bankName', '');
        formRef?.current?.setFieldValue('brdgxBankCode', '');
        formRef?.current?.setFieldValue('swift', '');
    }

    const handleBankNameClick = (value, code) => {
        setBankName(value);
        formRef?.current?.setFieldValue('bankName', value);
        formRef?.current?.setFieldValue('brdgxBankCode', code === undefined ? '' : code);
        setIsRequiredValidation(prevData => ({
            ...prevData,
            swift: code.trim() !== '' ? false : true
        }));
    }


    const handleAccountNumberChange = (value) => {
        setAccountType(ibanRegex.test(removeExcessChar(value)) ? 'AccountTypeIBAN' : accountRegex.test(removeExcessChar(value)) ? 'AccountTypeAccountNumber' : '');
    }

    const handleIntermediaryAccountNumberChange = (value) => {
        setIsRequiredValidation(prevData => ({
            ...prevData,
            intermediaryBankName: value.trim() !== '' ? true : false,
            intermediaryBankSWIFT: value.trim() !== '' ? true : false,
            intermediaryBankFullAddress: value.trim() !== '' ? true : false
        }));

        if (value.trim() === '') {
            formRef?.current?.setFieldValue('intermediaryBankName', '');
            formRef?.current?.setFieldValue('intermediaryBankSWIFT', '');
            formRef?.current?.setFieldValue('intermediaryBankFullAddress', '');
        }
    }
    //#endregion

    const removeExcessChar = (data) => {
        return data.charAt(0) === `'` ? data.slice(1) : data;
    }

    const submitMFA = async () => {
        setLoading(true);
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        };

        await get('/mfa/sendCodeBankUpdate', params).then((data) => {
            setMfaModalProperty({
                isModalOpen: true,
                maskedEmail: data.maskedEmail,
                referenceId: data.referenceId
            });

        }).catch(() => {
            setModalProperty({
                isModalOpen: true,
                icon: 'submit-error',
                title: 'Error',
                content: 'Error in submission. Please try again.'
            });

        });
        setLoading(false);
    }

    const handleCloseMFAModal = async () => {
        setMfaModalProperty({
            isModalOpen: false
        });
    }

    const submitBankDetails = async () => {
        const detail = formRef.current?.getFieldsValue();
        setLoading(true);
        let params = {
            ...detail,
            accessToken: user.accessToken,
            userId: user.userId,
            useFor: syndicationCurrency.toLowerCase() === 'usd' ? (document.getElementsByName('use-for-cad')[0].checked ? "CAD" : "") : (document.getElementsByName('use-for-usd')[0].checked ? "USD" : "")
        };

        let url = '';

        if (action === 'edit') {
            params.recId = bankAccountData.recId;
            url = '/bankAccount/update';
        }
        else {
            params.recId = null;
            url = '/bankAccount/create';
            params.syndicationCurrency = syndicationCurrency.trim().toUpperCase();
        }

        await post(url, params).then((data) => {
            if (data.message === 'Success') {
                setModalProperty({
                    isModalOpen: true,
                    icon: 'submit-success',
                    title: 'Submitted',
                    content: 'Successfully submitted.'
                });
            }
            else {
                setModalProperty({
                    isModalOpen: true,
                    icon: 'submit-error',
                    title: 'Error',
                    content: 'Error in submission. Please try again.'
                });
            }
        }).catch(() => {
            setModalProperty({
                isModalOpen: true,
                icon: 'submit-error',
                title: 'Error',
                content: 'Error in submission. Please try again.'
            });
        });
        setLoading(false);
    };

    const handleUseFor = async (value, syndication) => {
        setUseFor({
            usd: syndication === 'usd' ? value : false,
            cad: syndication === 'cad' ? value : false
        })
    }

    return (
        ((user.sfUserType === 'CL' && user?.features?.filter(x => x.featureName === 'Bank Account Information')[0]?.isEnabled)
            || (user.sfUserType === 'IR' && previewDetail?.features?.filter(x => x.featureName === 'Bank Account Information')[0]?.isEnabled)) && <>
            {loading && <Loading />}
            <BankAccountSubmitSuccessPopUp isModalOpen={modalProperty.isModalOpen} icon={modalProperty.icon} title={t(modalProperty.title)} content={t(modalProperty.content)} handleOk={goto} />
            <BankAccountMFAPopUp isModalOpen={mfaModalProperty.isModalOpen} maskedEmail={mfaModalProperty.maskedEmail} referenceId={mfaModalProperty.referenceId} handleClose={handleCloseMFAModal} handleSave={() => submitBankDetails()} handleMFA={submitMFA} handleContactUs={contactUs} />

            <BankAccountDisclaimerModal isModalOpen={disclaimerModalProperty.isModalOpen} content={disclaimerModalProperty.type === 'Disclaimer' ? disclaimerModalProperty.contentDisclaimer : disclaimerModalProperty.contentFee} handleClose={() => viewDisclaimer('', false)} />
            <div className='bank-account-form'>
                <div className='main-box'>
                    <div className='submit-box bank-account-container'>
                        <div className='bank-account-form-div'>
                            <Form autoComplete="off" ref={formRef} scrollToFirstError>
                                {
                                    action.toLowerCase() === 'view' && (<>
                                        <div className='view-only'>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5888 8.95286C18.7326 6.22985 21.0036 4.5 24 4.5C26.9963 4.5 29.2673 6.22985 31.4111 8.95286C33.5195 11.6309 35.7539 15.5926 38.6127 20.6613L39.4835 22.2053C41.8467 26.3953 43.7132 29.7045 44.6936 32.3608C45.6955 35.0752 45.9336 37.5398 44.4179 39.7139C42.9472 41.8235 40.4933 42.6867 37.3983 43.0942C34.3151 43.5 30.1689 43.5 24.8496 43.5H23.1504C17.831 43.5 13.6848 43.5 10.6016 43.0942C7.50661 42.6867 5.05273 41.8235 3.58198 39.7139C2.06636 37.5398 2.30437 35.0752 3.30627 32.3608C4.28667 29.7046 6.15317 26.3953 8.51636 22.2054L9.38721 20.6614C12.246 15.5926 14.4804 11.6309 16.5888 8.95286ZM18.9459 10.8086C16.9979 13.283 14.8741 17.0398 11.9299 22.2599L11.2026 23.5494C8.75013 27.8977 7.00736 30.9973 6.12068 33.3996C5.2454 35.7709 5.36675 37.0282 6.04296 37.9982C6.76404 39.0325 8.11746 39.7413 10.9932 40.1198C13.8572 40.4968 17.8052 40.5 23.2726 40.5H24.7273C30.1947 40.5 34.1427 40.4968 37.0067 40.1198C39.8825 39.7413 41.2359 39.0325 41.9569 37.9982C42.6332 37.0282 42.7545 35.7709 41.8792 33.3996C40.9925 30.9973 39.2498 27.8977 36.7973 23.5494L36.07 22.2599C33.1258 17.0397 31.002 13.283 29.054 10.8086C27.124 8.35731 25.6251 7.5 24 7.5C22.3748 7.5 20.8759 8.35731 18.9459 10.8086Z" fill="#E3401E" />
                                                <path d="M24 14.5039C24.8284 14.5039 25.5 15.1755 25.5 16.0039V26.0039C25.5 26.8323 24.8284 27.5039 24 27.5039C23.1716 27.5039 22.5 26.8323 22.5 26.0039V16.0039C22.5 15.1755 23.1716 14.5039 24 14.5039Z" fill="#E3401E" />
                                                <path d="M24 34.0039C25.1046 34.0039 26 33.1085 26 32.0039C26 30.8993 25.1046 30.0039 24 30.0039C22.8954 30.0039 22 30.8993 22 32.0039C22 33.1085 22.8954 34.0039 24 34.0039Z" fill="#E3401E" />
                                            </svg>
                                            <span dangerouslySetInnerHTML={{ __html: viewOnlyDisclaimer }}></span>
                                        </div></>)
                                }
                                {
                                    action.toLowerCase() !== 'view' && (<div className='bank-account-form-tiles'>
                                        <div className='read-more'>
                                            <p className='bold'>{t('Please ensure your bank details are accurate and complete.')}</p>
                                            <p>{t('This account will be your default payment method for all future USD/CAD distributions from Walton and its affiliates.')}</p>
                                            {
                                                !showMore && <span onClick={() => setShowMore(true)}>{t('Read More')}</span>
                                            }
                                        </div>
                                        {
                                            showMore && (<>
                                                <div className='read-more'>
                                                    <p>{t('Incomplete or incorrect banking information may cause processing delays, rejections, returns, currency exchange discrepancies, or additional bank fees. Walton is not liable for such issues or any resulting charges or penalties, which may be deducted from your proceeds. You are solely responsible for ensuring the accuracy of the information provided.')}</p>
                                                    <span onClick={() => setShowMore(false)}>{t('Read Less')}</span>
                                                </div>
                                            </>)
                                        }
                                        <p className="bank-account-form-note">{t('Please complete this form in English.')}</p>
                                    </div>)
                                }

                                <div className='bank-account-form-tiles'>
                                    <p className="bank-account-form-title">{action === 'view' ? t('View Bank Account Information') + ' (' + syndicationCurrency + ')' : action === 'add' ? t('Create Bank Account Information') : t('Update Bank Account Information')} {action.toLowerCase() !== 'view' && <> - {syndicationCurrency.toLowerCase() === 'usd' ? t('USD Distribution') : t('CAD Distribution')}</>} </p>
                                    <div className='col-md-12 row bank-account-form-details'>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('BankCountry')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="bankCountry"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select onChange={(e) => handleBankCountryChange(e.target.value)} disabled={action.toLowerCase() === 'view' ? "disabled" : null}>
                                                        {
                                                            mOPCountries != null && (<>
                                                                {
                                                                    mOPCountries?.map((country) => (<>
                                                                        <option value={country.countryCode}>{country.countryName}</option>
                                                                    </>))
                                                                }
                                                            </>)
                                                        }
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Bank Name')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="bankName"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: bankNameRegex, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <Dropdown drop='down' show={isBankNameMenuOpen} onToggle={() => setIsBankNameMenuOpen(!isBankNameMenuOpen)} onChange={(e) => { handleBankNameChange(e.target.value) }}>
                                                        <Dropdown.Toggle as="textarea" type='textarea' className='bank-dropdown form-control' value={bankName} onClick={() => setIsBankNameMenuOpen(!isBankNameMenuOpen)} disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                        {
                                                            bankNameRegex.test(bankName) && (<>
                                                                <Dropdown.Menu className='bank-dropdown-menu' style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                                    {
                                                                        brdgXCodes?.map((brdgXCode) => (<>
                                                                            <Dropdown.Item eventKey={brdgXCode.description} onClick={() => handleBankNameClick(brdgXCode.description, brdgXCode.code)}>
                                                                                {brdgXCode.description}
                                                                            </Dropdown.Item>
                                                                        </>))
                                                                    }
                                                                </Dropdown.Menu>
                                                            </>)
                                                        }
                                                    </Dropdown>
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('BankFullAddress')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="bankFullAddress"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: /^[A-Za-z0-9 ,.#()\/&'-]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <textarea type='text' name='bankFullAddress' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span style={{ marginBottom: "35px" }}>
                                                    {t('AccountHolderName')}
                                                    <i className='required'>*</i>
                                                </span>


                                                <div className='pop-over'>
                                                    <FormItem
                                                        name="bankAccountName"
                                                        rules={[{ required: true, message: t('This field is required') },
                                                        { pattern: /^[A-Za-z ,.-]+$/, message: t('Invalid input') }]}
                                                    >
                                                        <input type='text' name='bankAccountName' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                    </FormItem>

                                                    <Popover
                                                        title={t('AccountHolderName')}
                                                        content={
                                                            <div>
                                                                <p>{t('Please fill in the bank account on the bank account statement.')}</p>
                                                            </div>
                                                        }

                                                        className='pop-over-container'

                                                    >
                                                        <svg
                                                            className="svg-circle"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                                fill="#003448"
                                                            />
                                                        </svg>
                                                        <svg
                                                            className="svg-exclamation"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="2"
                                                            height="10"
                                                            viewBox="0 0 2 10"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                                fill="#003448"
                                                            />
                                                            <path
                                                                d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                                fill="#003448"
                                                            />
                                                        </svg>
                                                    </Popover>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('AccountHolderLastName')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="accountHolderLastName"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: /^[A-Za-z -]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='accountHolderLastName' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                            <div className='col-md-6 details' >
                                                <span>{t('AccountHolderFirstName')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="accountHolderFirstName"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: /^[A-Za-z .-]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='accountHolderFirstName' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details'>
                                                <span style={{ marginBottom: "30px" }}>
                                                    {t('AccountNumber/IBAN')}
                                                    <i className='required'>*</i>
                                                </span>
                                                <div style={{ display: "grid" }}>
                                                    <FormItem
                                                        name="accountNumber"
                                                        rules={[{ required: true, message: t('This field is required') },
                                                        { pattern: accountNumberOrIBANRegex, message: t('Please enter valid account number or IBAN.') }]}
                                                    >
                                                        <input type='text' style={{ marginTop: "10px" }} name='accountNumber' disabled={action.toLowerCase() === 'view' ? "disabled" : null} onChange={(e) => handleAccountNumberChange(e.target.value)} />
                                                    </FormItem>
                                                    {
                                                        accountType !== '' && (<div className='account-number-hint'>
                                                            {t(accountType)}
                                                        </div>)
                                                    }

                                                    <div className='pop-over'>
                                                        <Popover
                                                            title={t('AccountNumber/IBAN')}
                                                            content={
                                                                <div>
                                                                    <p>{t('For HSBC HK, Account No. must be 10 or 12 digits.')}</p>
                                                                    <p>{t('IBAN is required for Isle of Man, Guernsey, Jersey, Channel Islands, all European countries & Middle East')}</p>
                                                                </div>
                                                            }
                                                            className='pop-over-container-accounttype'
                                                        >
                                                            <svg
                                                                className="svg-circle"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                                    fill="#003448"
                                                                />
                                                            </svg>
                                                            <svg
                                                                className="svg-exclamation"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="2"
                                                                height="10"
                                                                viewBox="0 0 2 10"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                                    fill="#003448"
                                                                />
                                                                <path
                                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                                    fill="#003448"
                                                                />
                                                            </svg>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span style={{ marginBottom: "30px" }}>{t('BridgeX Code')}</span>
                                                <div style={{ display: "grid" }}>
                                                    <div className='pop-over'>
                                                        <FormItem
                                                            name="brdgxBankCode"
                                                            rules={[{ required: false, message: t('This field is required') }]}
                                                        >
                                                            <input type='text' name='brdgxBankCode' disabled={"disabled"} />
                                                        </FormItem>

                                                        <Popover
                                                            title={t('BridgeX Code')}
                                                            content={
                                                                <div>
                                                                    <p>{t('This is for internal use only, you are not required to fill in this field.')}</p>
                                                                </div>
                                                            }
                                                            className='pop-over-container-bridgex'
                                                        >
                                                            <svg
                                                                className="svg-circle"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                                    fill="#003448"
                                                                />
                                                            </svg>
                                                            <svg
                                                                className="svg-exclamation"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="2"
                                                                height="10"
                                                                viewBox="0 0 2 10"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                                    fill="#003448"
                                                                />
                                                                <path
                                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                                    fill="#003448"
                                                                />
                                                            </svg>
                                                        </Popover>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='col-md-6 details' >
                                                <span>{t('SWIFT Code/BIC Code')} {isRequiredValidation.swift ? <i className='required'>*</i> : null}</span>
                                                <FormItem
                                                    name="swift"
                                                    rules={[{ required: isRequiredValidation.swift, message: t('This field is required') },
                                                    { pattern: /^[A-Za-z0-9]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='swift' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>

                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span style={{ marginBottom: "55px" }}>{t('Branch Code/Routing Number/Sort Code')}{branchCodeNote !== '' ? <i className='required'>*</i> : null}</span>
                                                <div style={{ display: "grid" }}>
                                                    <FormItem
                                                        name="branchCode"
                                                        rules={[{ required: branchCodeNote !== '' ? true : false, message: t('This field is required') },
                                                        { pattern: /^[A-Za-z0-9]+$/, message: t('Invalid input') }
                                                        ]}
                                                    >
                                                        <input type='text' name='branchCode' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                    </FormItem>
                                                    {
                                                        branchCodeNote !== '' && (<div className='account-number-hint' style={{marginTop: "-5px"}} >
                                                            {t(branchCodeNote)}
                                                        </div>)
                                                    }
                                                </div>

                                            </div>
                                            <div className='col-md-6 details' >
                                                <span>{t('Bank Code')}<i className={user.salesOffice === 'SG' ? 'hide' : 'required'}>*</i></span>
                                                <FormItem
                                                    name="bankCode"
                                                    rules={[{ required: user.salesOffice === 'SG' ? false : true, message: t('This field is required') },
                                                    { pattern: /^[0-9]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='bankCode' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Receiving Currency')}<i className='required'>*</i></span>
                                                <FormItem
                                                    name="accountCurrency"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select name='accountCurrency' disabled={action.toLowerCase() === 'view' ? "disabled" : null}>
                                                        {
                                                            mOPCurrencies != null && (<>
                                                                {
                                                                    mOPCurrencies?.map((currency) => (<>
                                                                        <option value={currency.currency}>{currency.currency}</option>
                                                                    </>))
                                                                }
                                                            </>)
                                                        }
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='bank-account-form-tiles'>
                                    <p className="bank-account-form-title">{t('Intermediary Bank Information (if applicable)')}</p>
                                    <div className='col-md-12 row bank-account-form-details'>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Intermediary Bank Account Number (if any)')}</span>
                                                <FormItem
                                                    name="intermediaryBankAccountNumber"
                                                    rules={[{ required: false, message: t('this field is required') },
                                                    { pattern: /^\d{6,25}$/, message: t('Please enter valid intermediate account number.') }
                                                    ]}
                                                >
                                                    <input type='text' name='intermediaryBankAccountNumber' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Intermediary Bank Name')}{isRequiredValidation.intermediaryBankName ? <i className='required'>*</i> : null}</span>
                                                <FormItem
                                                    name="intermediaryBankName"
                                                    rules={[{ required: false, message: t('this field is required') },
                                                    { pattern: /^[A-Za-z0-9 ,.#-()]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='intermediaryBankName' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Intermediary Bank SWIFT Code/BIC Code')}{isRequiredValidation.intermediaryBankSWIFT ? <i className='required'>*</i> : null}</span>
                                                <FormItem
                                                    name="intermediaryBankSWIFT"
                                                    rules={[{ required: false, message: t('this field is required') },
                                                    { pattern: /^[A-Za-z0-9]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <input type='text' name='intermediaryBankSWIFT' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row'>
                                            <div className='col-md-6 details' >
                                                <span>{t('Intermediary Bank Full Address')}</span>
                                                <FormItem
                                                    name="intermediaryBankFullAddress"
                                                    rules={[{ required: false, message: t('this field is required') },
                                                    { pattern: /^[A-Za-z0-9 ,.#()\/&'-]+$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <textarea type='text' name='intermediaryBankFullAddress' disabled={action.toLowerCase() === 'view' ? "disabled" : null} />
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    action.toLowerCase() !== 'view' && (<>
                                        <div className='bank-account-form-tiles'>
                                            <p className="bank-account-form-title">{t('UseThisBankDetailsFor')}</p>
                                            <div className='bank-account-use-for-hint'>
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.2944 4.97252C9.36631 3.61102 10.5018 2.74609 12 2.74609C13.4981 2.74609 14.6336 3.61102 15.7055 4.97252C16.7598 6.31155 17.8769 8.29237 19.3063 10.8267L19.7418 11.5988C20.9234 13.6937 21.8566 15.3484 22.3468 16.6765C22.8478 18.0337 22.9668 19.266 22.209 20.353C21.4736 21.4079 20.2466 21.8395 18.6991 22.0432C17.1576 22.2461 15.0845 22.2461 12.4248 22.2461H11.5752C8.9155 22.2461 6.8424 22.2461 5.30082 22.0432C3.75331 21.8395 2.52637 21.4079 1.79099 20.353C1.03318 19.266 1.15218 18.0337 1.65314 16.6765C2.14334 15.3484 3.07658 13.6937 4.25818 11.5988L4.69361 10.8268C6.123 8.29239 7.24018 6.31156 8.2944 4.97252ZM9.47297 5.90041C8.49896 7.13757 7.43704 9.01597 5.96495 11.626L5.60129 12.2708C4.37507 14.4449 3.50368 15.9947 3.06034 17.1959C2.6227 18.3816 2.68338 19.0102 3.02148 19.4952C3.38202 20.0123 4.05873 20.3667 5.49659 20.556C6.92858 20.7445 8.9026 20.7461 11.6363 20.7461H12.3636C15.0973 20.7461 17.0714 20.7445 18.5034 20.556C19.9412 20.3667 20.6179 20.0123 20.9785 19.4952C21.3166 19.0102 21.3773 18.3816 20.9396 17.1959C20.4963 15.9947 19.6249 14.4449 18.3987 12.2708L18.035 11.626C16.5629 9.01596 15.501 7.13757 14.527 5.90041C13.562 4.67475 12.8126 4.24609 12 4.24609C11.1874 4.24609 10.4379 4.67475 9.47297 5.90041Z" fill="#E3401E" />
                                                    <path d="M12 7.74609C12.4142 7.74609 12.75 8.08188 12.75 8.49609V13.4961C12.75 13.9103 12.4142 14.2461 12 14.2461C11.5858 14.2461 11.25 13.9103 11.25 13.4961V8.49609C11.25 8.08188 11.5858 7.74609 12 7.74609Z" fill="#E3401E" />
                                                    <path d="M12 17.4961C12.5523 17.4961 13 17.0484 13 16.4961C13 15.9438 12.5523 15.4961 12 15.4961C11.4477 15.4961 11 15.9438 11 16.4961C11 17.0484 11.4477 17.4961 12 17.4961Z" fill="#E3401E" />
                                                </svg>
                                                <p>{t('ThisWillOverwriteExistingBankAccountInformation.') + t('AreYouSureYouWantToProceed')}</p>
                                            </div>
                                            <div className='bank-account-use-for-check'>
                                                <div>
                                                    <input type='checkbox' name='use-for-usd' onClick={(e) => handleUseFor(e.target.checked, 'usd')} /> <span>{t('USD Distribution')}</span>
                                                </div>
                                                <div>
                                                    <input type='checkbox' name='use-for-cad' onClick={(e) => handleUseFor(e.target.checked, 'cad')} /> <span>{t('CAD Distribution')}</span>
                                                </div>
                                                {syndicationCurrency.toLowerCase() === 'usd' ? (<>{useFor.cad && <p>{t('Use_For_CAD')}</p>} </>) : (<>{useFor.usd && <p>{t('Use_For_USD')}</p>}</>)}
                                            </div>
                                        </div>
                                    </>)
                                }

                                <div className='bank-account-form-tiles'>
                                    <div className='agree'>
                                        {
                                            action.toLowerCase() !== 'view' && (<>
                                                {
                                                    userAgree ? (<>
                                                        <svg onClick={() => setUserAgree(false)} width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <ellipse cx="11.3514" cy="12" rx="11.3514" ry="12" fill="#FFC81C" />
                                                            <path d="M17.71 8.31595C17.3462 7.91041 16.7396 7.89255 16.3554 8.27813L10.2381 14.411L7.32038 11.2441C6.95083 10.8433 6.34493 10.8345 5.96546 11.2252C5.58631 11.6156 5.57833 12.2568 5.94755 12.6576L9.5249 16.5403C9.71237 16.7439 9.96152 16.8466 10.2113 16.8466C10.4483 16.8466 10.6853 16.754 10.8709 16.5687L17.6743 9.748C18.0582 9.36305 18.0744 8.72184 17.71 8.31595Z" fill="#003448" />
                                                        </svg>

                                                    </>) : (<>
                                                        <svg onClick={() => setUserAgree(true)} width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <ellipse cx="11.3514" cy="12" rx="11.3514" ry="12" fill="#FFC81C" />
                                                        </svg>
                                                    </>)
                                                }

                                            </>)
                                        }
                                        <p dangerouslySetInnerHTML={{ __html: action.toLowerCase() === 'view' ? t('View_Submit_Agreement') : t('Submit_Agreement') }} />
                                    </div>
                                </div>

                                <div className='col-md-12 row bank-account-form-button'>
                                    <button type='button' onClick={() => goto()}>{t('Back')}</button>
                                    {
                                        action.toLowerCase() !== 'view' && userAgree && <button type='submit' onClick={() => submitBankAccount()} disabled={user.sfUserType === 'CL' ? false : true}>{t('Submit')}</button>
                                    }
                                </div>
                                {
                                    action.toLowerCase() === 'view' && (<>
                                        <div className='col-md-12 row bank-account-form-customer-service'>
                                            <p>{t('If you would like to update your bank account details or have any questions, please contact')}</p>
                                            <span onClick={() => contactUs()}>{t('Client Services')}</span>
                                            <p>{t('Bank_CS_End')}</p>
                                        </div>
                                    </>)
                                }

                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>)
}